import { Select, SelectTrigger, SelectValue, SelectContent, SelectItem } from '@/components/ui/select'
import { Label } from '@/components/ui/label'
import type { AvatarOption } from './avatarOptions'

interface AvatarSelectGroupProps {
  label: string
  options: AvatarOption[]
  selected: string | undefined
  onSelect: (value: string) => void
  disabled?: boolean
}

export function AvatarSelectGroup({ label, options, selected, onSelect, disabled }: AvatarSelectGroupProps) {
  return (
    <div className="grid gap-2">
      <Label>{label}</Label>
      <Select value={selected || ''} onValueChange={onSelect} disabled={disabled}>
        <SelectTrigger className="w-full">
          <SelectValue placeholder={label} />
        </SelectTrigger>
        <SelectContent>
          {options.map((o) => (
            <SelectItem key={o.value} value={o.value}>{o.label}</SelectItem>
          ))}
        </SelectContent>
      </Select>
    </div>
  )
}
